<div *ngIf="testState && !testState.isSubmitted" class="screen-warning">
    <tra slug="error_small_screen"></tra>
</div>

<div *ngIf="!testState.isSubmitted && !isPrintMode && !isShowingConfirmationReport" class="question-content-frame" [class.is-wide-load]="containsWideLoad()" [class.is-hi-contrast]="isHighContrast">

    <div class="screen-reader-shortcut">
        <i class="fa fa-keyboard-o screen-reader-shortcut__icon" aria-hidden="true"></i>
        <a href="#current-question-heading" class="screen-reader-shortcut__action"
            (click)="skipToCurrentQuestion($event)">
            <tra slug="sr_skip_to_current_question"></tra>
        </a>
        <span class="screen-reader-shortcut__label" aria-hidden="true">
            <tra slug="sr_shortcut_toolbar"></tra>
        </span>
    </div>

    <button *ngIf="!showDeactivatedMode && isShowOverlay" style="position:fixed; font-weight:bold; cursor:pointer; z-index:10; height:60px; right:5%; bottom:2%; background:#2A304B; margin:auto; border-top-left-radius: 1.3em; border-top-right-radius: 1.3em; padding:0 1em; color:white; font-size:1.2em;"
        (click)="disableOverlay()">
        {{lang.tra('draw_tool_exit')}}
    </button>

    <!-- <div *ngIf="isShowFormulaSheet" class="formula-container">
        <div class="formula-container__sheet">
            <div class="formula-container__sheet-header">
                <p>Formula Sheet</p>
                <button (click)="toggleFormula()"> <i class="fas fa-times"></i></button>
            </div>
        </div> -->

<!-- <div *ngIf="!testState.isSubmitted && !isPrintMode && !isShowingConfirmationReport"
     class="question-content-frame"
     [class.is-wide-load]="containsWideLoad()"
     [class.is-hi-contrast]="isHighContrast"
     [ngStyle]="{'font-size.em': zoomLevel}"
>
  <div *ngIf="!isHelpOverlay" class="question-content">
    <div class="question-content-constrainer is-fixedwidth" style="margin-bottom:2em;">
      <div class="question-loc-sm">
          <tra slug="title_section"></tra> {{testState.currentSectionIndex+1}},
          <tra slug="title_question"></tra> {{testState.currentQuestionIndex+1}}
      </div>
      <div style="position:relative" #topBar  [class.is-hidden]="isLineReaderActive">
          <progress
            class="progress is-info"
            style="margin-bottom:0px;"
            [value]="getCurrentProgressLoc(true)"
            max="100"
          >{{getCurrentProgressLoc()}}</progress>
          <div
            *ngFor="let section of currentTestDesign.sections; let isLast = last"
            class="section-progress-marker"
            [ngStyle]="{left: section.__meta.markLoc}"
            [class.is-hidden]="isLast"
          > </div>
      </div> -->
  <div *ngIf="isLineReaderActive">
    <div class="line-reader-container" id="quest-reader" [ngStyle]="{'zoom.%':currIEZoom}">
      <div cdkDrag class="line-reader" [cdkDragFreeDragPosition]="lineReaderPosition">
        <div class="line-reader-top"></div>
        <div class="line-reader-left"></div>
        <div class="line-reader-right"></div>
        <div class="line-reader-bottom"></div>
      </div>
    </div>
  </div>
  <div *ngIf="isNotepadEnabled" class="notepad-wrapper">
    <div cdkDrag class="notepad-container">
        <div class="notepad-title">
            <tra slug="lbl_notepad"></tra>
        </div>
        <div *ngIf="getNotepadText()" class="notepad-text-preview">
            {{getNotepadText()}}
        </div>
        <textarea
          class="textarea notepad-textarea"
          spellcheck="false"
          (mousedown)="$event.stopPropagation()"
          [(ngModel)]="testState.notes"
          (ngModelChange)="logStartTyping()"
          (blur)="handleBlur()"
        ></textarea>
    </div>
  </div>
  <main class="question-content" id="quest-cont">
        <h1 id="current-question-heading" #currentQuestionHeading class="screen-reader-only" tabindex="-1"
            [attr.aria-label]="getCurrentQuestionHeadingText()"
            [textContent]="getCurrentQuestionHeadingText()">
        </h1>
        <div class="question-content-constrainer is-fixedwidth progress-bar-container">
            <div class="question-loc-sm">
                <tra slug="title_stage"></tra> {{testState.currentSectionIndex+1}},
                {{ getCurrentQuestionTitle(testState.currentQuestionIndex, getActiveQuestionContent()) }}
            </div>
            <div style="position:relative" #topBar [class.is-hidden]="isLineReaderActive">
                <progress class="progress is-info" style="margin-bottom:0px;" [value]="getCurrentProgressLoc(true)" max="100">{{getCurrentProgressLoc()}}</progress>
                <div *ngFor="let section of currentTestDesign.sections; let isLast = last" class="section-progress-marker" [ngStyle]="{left: section.__meta.markLoc}" [class.is-hidden]="isLast"> </div>
            </div>
        </div>
        <section class="split-wrapper" [class.split-open]="(isCalcAvailable() && isShowingCalc()) || isShowDocuments"
            aria-labelledby="current-question-heading">
            <div class="helper-tools">
        
                <div class="question-left-scroll-panel">
                    <div class="question-content-constrainer" #questionDisplay>
        
                        <div [ngStyle]="{'font-size.em': zoomLevel}">
        
                            <div *ngIf="isShowingSectionInfo && getCurrentSectionPreambleContent()" style="position: relative;">
                                <div style="font-size: 2em; color: #3298dc; position:absolute; left:-1em; top:0.1em;">
                                    <i class="fa fa-info"></i>
                                </div>
                                <question-runner [currentQuestion]="getCurrentSectionPreambleContent()"
                                    [currentQuestionIndex]="0" [totalQuestions]="4"></question-runner>
                            </div>
        
                            <div class="next-button-container" *ngIf="isShowingSectionInfo">
                                <button (click)="hideSectionInfo()" class="button is-large is-info ">
                                    <tra slug="btn_next_question_mpt"></tra>
                                </button>
                            </div>
        
                            <div [class.is-hidden]="isShowingSectionInfo">
                                <question-runner [currentQuestion]="getActiveQuestionContent()" [currentQuestionIndex]="0"
                                    [totalQuestions]="4" [questionState]="getActiveQuestionState()"></question-runner>
                            </div>
        
                            <div class="next-button-container" [class.is-hidden]="isShowingSectionInfo">
                                <button id="btn-submit-question" [disabled]="!isCurrentQuestionFilled()"
                                    *ngIf="!isOnLastQuestion()" (click)="gotoNextQuestion()" class="button is-large is-info">
                                    <tra slug="btn_next_question_mpt"></tra>
                                </button>
                                <button id="btn-submit-question" [disabled]="!isCurrentQuestionFilled()"
                                    *ngIf="isOnLastQuestion()" [disabled]="isSubmitting" (click)="reviewAndSubmit()"
                                    class="button is-large is-info">
                                    <tra slug="btn_review_submit"></tra>
                                </button>
                            </div>
                        </div>
                        <div *ngIf="!isShowingSectionInfo" class="screen-reader-shortcut">
                            <i class="fa fa-keyboard-o screen-reader-shortcut__icon" aria-hidden="true"></i>
                            <a href="#current-question-heading" class="screen-reader-shortcut__action"
                                (click)="skipToCurrentQuestion($event)">
                                <tra slug="sr_back_to_current_question"></tra>
                            </a>
                            <span class="screen-reader-shortcut__label" aria-hidden="true">
                                <tra slug="sr_shortcut_toolbar"></tra>
                            </span>
                        </div>

                        <div *ngIf="isShowOverlay" class="question-content__overlay"
                            [ngClass]="{'deactivated':showDeactivatedMode}" id="draw-overlay">
                            <element-render-drawing id="test-runner" [parent]="getDrawingDisplayMode()"
                                [currId]="getActiveQuestionId()" [activatedState]="!showDeactivatedMode"
                                [useEraser]="showEraser" [useHighlighter]="showHighlight" [useLine]="showLine"
                                [zoomLevel]="zoomLevel" [isZoomIn]="isZoomIn" [isFrameEnabled]="false"
                                [isToolbarEnabled]="false"></element-render-drawing>
                        </div>
                        <div class="question-content__faux-overlay" [class.animateDown]="isShowOverlay && !showDeactivatedMode"
                            [class.animateUp]="showDeactivatedMode"></div>
                    </div>
                </div>
        
                <div class="calculator-split-side" *ngIf="(isCalcAvailable() && isShowingCalc()) || isShowDocuments">
        
                    <div class="documents-split-container documents-container" *ngIf="isShowDocuments"
                        style="width: 100%; padding: 0 2em 2em 2em;">
                        <div [ngStyle]="{'font-size.em': zoomLevel}">
                            <div
                                style="display:flex; flex-direction:row; justify-content: space-between; border-bottom: 1px solid #ccc; padding-bottom: 0.5em; margin-bottom: 1em;">
                                <menu-bar style="flex-grow:1" [menuTabs]="documentViews" (change)="selectDocumentView($event)"
                                    [tabIdInit]="selectedDocumentId"></menu-bar>
                                <a style="font-size:1.4em; cursor: pointer; margin-left: 1em; text-decoration: none;"
                                    (click)="isShowDocuments = false">&times;</a>
                            </div>
                            <div *ngIf="activeDocument">
                                <question-runner [currentQuestion]="activeDocument" [currentQuestionIndex]="0"
                                    [totalQuestions]="4"></question-runner>
                            </div>
                        </div>
                    </div>
        
                    <widget-calculator *ngIf="isCalcAvailable() && isShowingCalc()" [isSimple]="true"
                        (logStudentCalcAction)="logCalculatorAction()" [zoom]="zoomLevel"></widget-calculator>
        
                </div>
        
            </div>
        </section>
    </main>
    <div *ngIf="isHelpOverlay" class="question-content question-content-help" [id]="getToolbarPanelId('help')">
        <div class="question-content-constrainer is-fixedwidth" style="margin-bottom:2em;" >
            <div  [ngStyle]="{'font-size.em': zoomLevel}">
                <question-runner [currentQuestion]="getHelpScreenLayout()" [currentQuestionIndex]="0" [totalQuestions]="4"></question-runner>
            </div>
        </div>
    </div>
</div>



<div class="test-nav" [class.is-expanded]="isTestNavExpanded" *ngIf="!isLineReaderActive && !isPrintMode">
    <div>
        <div class="collapser">
            <button class="button" (click)="toggleTestNav()" aria-label="Collapse question navigation" [attr.aria-expanded]="getAriaExpanded(isTestNavExpanded)" [attr.aria-controls]="getTestNavId()">
                <i class="fa fa-angle-double-left" aria-hidden="true"></i>
            </button>
        </div>
        <div class="support" *ngIf="false && isIssueReportingEnabled">
            <button (click)="reportIssue()">
                <img src="https://mathproficiencytest.ca/img/red-flag.png">
                <tra slug="btn_report_issue"></tra>
            </button>
        </div>

        <div *ngIf="isExitEnabled">
            <button class="button is-small is-fullwidth  is-danger has-icon" (click)="exit.emit()">
                <span class="icon"><i class="fa fa-times"></i></span>
                <span>Exit Preview</span>
            </button>
            <label style="display: inline-flex; align-items: center; cursor: pointer;">
                <input type="checkbox" [(ngModel)]="isLogsVisible">
                <span style="margin-left: 10px;">Show Process Logs</span>
              </label>
            <div *ngIf="isLogsVisible" style="margin-top: 1em">
                <button class="button is-small is-danger is-light" (click)="exportLogsJson()">Download</button>
                <div>
                    Filter in: <input [(ngModel)]="logsFilterIn" type="text">
                </div>
                <div>
                    Filter out: <input [(ngModel)]="logsFilterOut" type="text">
                </div>
                <div style="overflow:auto; max-height:20em;">
                    <table>
                        <tr>
                            <th>event</th>
                            <th>localTimestamp</th>
                            <th>section_index</th>
                            <th>question_index</th>
                            <th style="width:8em">info</th>
                            <th>isSimulated</th>
                            <th>counter</th>
                        </tr>
                        <ng-container *ngFor="let log of logQueue">
                            <tr *ngIf="checkShowLog(log.slug)" >
                                <td>{{log.slug}}</td>
                                <td>{{log.data.localTimestamp}}</td>
                                <td>{{log.data.state.section_index}}</td>
                                <td>{{log.data.state.question_index}}</td>
                                <td>{{log._info}}</td>
                                <td>{{log.data.isSimulated}}</td>
                                <td>{{log.counter}}</td>
                            </tr>
                        </ng-container>
                    </table>
                </div>
            </div>
        </div>
        <div *ngIf="isShowQuestionLabel">
            <button class="button is-small is-fullwidth is-grey  has-icon" (click)="showCurrentQuestionLabel()">
                <span class="icon"><i class="fa fa-info"></i></span>
                <span>Identify Current Question</span>
            </button>
        </div>

        <div class="identity">
            <div class="identity-key"></div>
            <div class="identity-name">{{testTakerName}}</div>
            <div *ngIf="attemptKey" class="identity-key">
              <tra slug="txt_dummy_attempt_key"></tra>: {{attemptKey}}
            </div>
            <div *ngIf="showFPS" class="fps-frame" [class.fps-good]="currentFpsStatus === FPSStatus.GOOD" [class.fps-adequate]="currentFpsStatus === FPSStatus.ADEQUATE" [class.fps-poor]="currentFpsStatus === FPSStatus.POOR">
                <tra slug = 'sdc_const_fps'></tra>: {{currentFPS}} ({{currentFpsStatusText}}) 
            </div>
            <!-- Video Status Indicator -->
            <div class="video-status-indicator" *ngIf="isRemote" [class.online]="isVideoOnline" [class.offline]="!isVideoOnline">
                <i class="fas fa-video" [class.text-success]="isVideoOnline" [class.text-danger]="!isVideoOnline" aria-hidden="true"></i>&nbsp;
                <span class="status-text">{{ isVideoOnline ? this.lang.tra('lbl_online') : this.lang.tra('lbl_offline') }}</span>
            </div>
        </div>
        <div class="test-timing" *ngIf="!isNavFooterDisabled">
            <button (click)="checkTimeLeft()" *ngIf="isTimeEnabled" [attr.aria-label]="lang.tra('sr_timing_button')">
                <img src="https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/6388/authoring/clock/1612200967437/clock.svg" aria-hidden="true">
            </button>
            <button (click)="openChat()" *ngIf="isChatEnabled" [attr.aria-label]="lang.tra('sr_chat_button')">
                <i class="far fa-comments" aria-hidden="true"></i>
            </button>
            <button *ngIf="chatService.newMessage && !isShowingChat" (click)="openChat()" [attr.aria-label]="lang.tra('sr_chat_notif_button')">
                <a><i class="fa fa-envelope is-danger" aria-hidden="true"></i></a>
            </button>
            <button *ngIf="isRemote" (click)="reloadConference()"
              [attr.aria-label]="'Refresh video conference'"
              [tooltip]="lang.tra('mpt_call_refresh_lbl')"
              placement="left"
              aria-label="Refresh video conference"
            >
              <i class="fas fa-sync-alt" aria-hidden="true"></i>
            </button>
        </div>
        <div *ngIf="getLogo()" class="logo-container">
            <img [src]="getLogoSafe()">
        </div>

            <!-- <div class="test-title">
                <tra slug="brand_long"></tra>
            </div> -->

            <div class="test-section">
                <div *ngIf="currentTestDesign.sections.length > 1">
                    <tra [slug]="getSectionTitleSlug()"></tra>
                    {{(getCurrentSectionIndex() + 1)}}
                    <tra slug="of_enum"></tra>
                    {{currentTestDesign.sections.length}}
                </div>
                <button (click)="showSectionInfo()"
                  [attr.aria-label]="lang.tra('ie_preamble')"
                  class="button is-small"
                  [class.is-info]="isShowingSectionInfo"
                  *ngIf="getCurrentSectionPreambleContent()"
                  style="margin-left: 2em;"><i class="fa fa-info"></i>
                </button>
                <div *ngIf="getCurrSectionTimeLimit()" style="font-size: 0.85em; font-weight: 400;">
                    <tra [slug]="getSectionTimeRemainingSlug()"></tra>: {{sectionTimeRemaining}}
                </div>
            </div>
        </div>
        <div class="test-questions" [id]="getTestNavId()" role="navigation" aria-label="Question navigation">
            <button *ngFor="let question of getCurrentQuestions(); let qIndex = index;" class="question" (click)="selectQuestion(qIndex)" [class.is-active]="!isShowingSectionInfo && getCurrentQuestionIndex() === qIndex" [attr.aria-label]="getQuestionNavAriaLabel(qIndex)" [attr.aria-current]="getQuestionAriaCurrent(qIndex)">
                <span class="icon">
                    <i *ngIf="!isQuestionFilled(qIndex)" class="far fa-circle" [tooltip]="lang.tra('lbl_not_filled')" placement="left" aria-hidden="true"></i>
                    <i *ngIf="isQuestionFilled(qIndex)" class="fas fa-circle" [tooltip]="lang.tra('lbl_filled')" placement="left" aria-hidden="true"></i>
                </span>
                <span>
                    {{ getCurrentQuestionTitle(qIndex, getQuestionDef(question)) }}
                </span>
            </button>
            <button class="question" [disabled]="isSubmitting" (click)="reviewAndSubmit()" [attr.aria-label]="lang.tra('btn_review_submit')">
                <tra slug="btn_review_submit"></tra>
            </button>
        </div>
        <div class="test-timing" *ngIf="!isNavFooterDisabled">
            <button (click)="checkTimeLeft()" *ngIf="isTimeEnabled" [attr.aria-label]="lang.tra('sr_timing_button')">
                <img src="https://s3.ca-central-1.amazonaws.com/authoring.mathproficiencytest.ca/user_uploads/6388/authoring/clock/1612200967437/clock.svg" aria-hidden="true">
            </button>
            <button (click)="openChat()" *ngIf="isChatEnabled" [attr.aria-label]="lang.tra('sr_chat_button')">
                <i class="far fa-comments" aria-hidden="true"></i>
            </button>
            <button *ngIf="chatService.newMessage && !isShowingChat" (click)="openChat()" [attr.aria-label]="lang.tra('sr_chat_notif_button')">
                <a><i class="fa fa-envelope is-danger" aria-hidden="true"></i></a>
            </button>
            <button *ngIf="isRemote" (click)="reloadConference()"
              [attr.aria-label]="'Refresh video conference'"
              tooltip="Refresh video conference"
              placement="left"
              aria-label="Refresh video conference"
            >
              <i class="fas fa-sync-alt" aria-hidden="true"></i>
            </button>
        </div>
    </div>

    <div class="toolbar" #toolbarRef *ngIf="!isPrintMode" [id]="getToolbarId()" [class.is-expanded]="isToolbarExpanded" style="overflow-y:auto;" [style.padding-bottom.px]="getToolbarBottomPadding()" role="toolbar" aria-label="Test tools">
        <div class="tools-top">
            <button type="button" class="button collapser" (click)="toggleToolbar()" aria-label="Collapse toolbar" [attr.aria-expanded]="getAriaExpanded(isToolbarExpanded)" [attr.aria-controls]="getToolbarId()" data-test-id="toolbar-collapse">
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
            </button>
            <button class="toolbar-icon tool-help" [class.is-activated]="isHelpOverlay" (click)="toggleHelpScreen()"
                    [tooltip]="lang.tra('btn_help')" placement="left"  *ngIf="isHelpEnabled" [attr.aria-label]="lang.tra('btn_help')" [attr.aria-pressed]="getAriaPressed(isHelpOverlay)" [attr.aria-expanded]="getAriaExpanded(isHelpOverlay)" [attr.aria-controls]="getToolbarPanelId('help')">
                <!-- <img src="https://mathproficiencytest.ca/img/text-to-speech.png"> -->
                <i class="fa fa-question-circle" style="font-size: 2em;" aria-hidden="true"></i>
                <!-- Text to speech by Trevor Dsouza from the Noun Project -->
            </button>
            <button class="toolbar-icon" (click)="toggleTextToSpeech()" [class.is-active]="isTextToSpeechActive()"
                    *ngIf="isText2SpeechEnabled" [tooltip]="lang.tra('btn_listen')" placement="left" [attr.aria-label]="lang.tra('btn_listen')" [attr.aria-pressed]="getAriaPressed(isTextToSpeechActive())">
                <img src="https://mathproficiencytest.ca/img/text-to-speech.png" aria-hidden="true">
                <!-- Text to speech by Trevor Dsouza from the Noun Project -->
            </button>
            <ng-container *ngIf="asmtFmrk">
              <button *ngIf="asmtFmrk.toolbarOptions.zoomIn" class="toolbar-icon" (click)="zoomIn()" [tooltip]="lang.tra('btn_zoom_in')" placement="left" [attr.aria-label]="lang.tra('btn_zoom_in')">
                  <img src="https://mathproficiencytest.ca/img/zoom-in.png" aria-hidden="true">
              </button>
              <button *ngIf="asmtFmrk.toolbarOptions.zoomOut" class="toolbar-icon" (click)="zoomOut()" [tooltip]="lang.tra('btn_zoom_out')" placement="left" [attr.aria-label]="lang.tra('btn_zoom_out')">
                  <img src="https://mathproficiencytest.ca/img/zoom-out.png" aria-hidden="true">
              </button>
              <button *ngIf="asmtFmrk.toolbarOptions.lineReader" class="toolbar-icon" (click)="toggleLineReader()" [class.is-active]="isLineReaderActive"
                      [tooltip]="lang.tra('btn_line_reader')" placement="left" [attr.aria-label]="lang.tra('btn_line_reader')" [attr.aria-pressed]="getAriaPressed(isLineReaderActive)">
                  <img src="https://www.mathproficiencytest.ca/img/line_reader.png" aria-hidden="true">
              </button>
              <button *ngIf="asmtFmrk.toolbarOptions.hiContrast" class="toolbar-icon" (click)="toggleHiContrast()" [class.is-active]="isHighContrast" [tooltip]="lang.tra('btn_hi_contrast')"
                      placement="left" [attr.aria-label]="lang.tra('btn_hi_contrast')" [attr.aria-pressed]="getAriaPressed(isHighContrast)">
                  <!-- hi contrast -->
                  <img src="https://mathproficiencytest.ca/img/hi-contrast.png" aria-hidden="true">
              </button>
              <button *ngIf="asmtFmrk.toolbarOptions.toggleEditor" type="button" class="toolbar-icon" (click)="setLine()" [class.is-active]="isShowOverlay && !showDeactivatedMode && showLine" [tooltip]="lang.tra('btn_toggle_editor')" placement="left" [attr.aria-label]="lang.tra('btn_toggle_editor')" [attr.aria-pressed]="getAriaPressed(isShowOverlay && !showDeactivatedMode && showLine)" data-test-id="toolbar-draw-line">
                  <i class="fas fa-edit" style="font-size: 2em; color:white;" aria-hidden="true"></i>
              </button>
              <button *ngIf="asmtFmrk.toolbarOptions.highlighter" type="button" class="toolbar-icon" (click)="setHighlighter()" [class.is-active]="isShowOverlay && !showDeactivatedMode && showHighlight" [tooltip]="lang.tra('el_draw_highlighter')" placement="left" [attr.aria-label]="lang.tra('el_draw_highlighter')" [attr.aria-pressed]="getAriaPressed(isShowOverlay && !showDeactivatedMode && showHighlight)" data-test-id="toolbar-highlighter">
                  <i class="fas fa-highlighter" style="font-size: 2em; color:white;" aria-hidden="true"></i>
              </button>
              <button *ngIf="asmtFmrk.toolbarOptions.eraser" type="button" class="toolbar-icon" (click)="setEraser()" [class.is-active]="isShowOverlay && showEraser" [class.is-inactive]="!isShowOverlay || showDeactivatedMode" [tooltip]="lang.tra('btn_eraser')" placement="left" [attr.aria-label]="lang.tra('btn_eraser')" [attr.aria-pressed]="getAriaPressed(isShowOverlay && showEraser)" data-test-id="toolbar-eraser">
                  <i class="fas fa-eraser" style="font-size: 2em; color:white;" aria-hidden="true"></i>
              </button>
              <button *ngIf="asmtFmrk.toolbarOptions.notepad" class="toolbar-icon" (click)="toggleNotepad()" [class.is-active]="isNotepadEnabled"
                      [tooltip]="lang.tra('lbl_notepad')" placement="left" [attr.aria-label]="lang.tra('lbl_notepad')" [attr.aria-pressed]="getAriaPressed(isNotepadEnabled)" [attr.aria-expanded]="getAriaExpanded(isNotepadEnabled)" [attr.aria-controls]="getToolbarPanelId('notepad')">
                  <i class="fas fa-sticky-note" style="font-size: 2em; color:white;" aria-hidden="true"></i>
              </button>
            </ng-container>
            <ng-container *ngIf="!asmtFmrk">
              <button class="toolbar-icon" (click)="zoomIn()" [tooltip]="lang.tra('btn_zoom_in')" placement="left" [attr.aria-label]="lang.tra('btn_zoom_in')">
                <img src="https://mathproficiencytest.ca/img/zoom-in.png" aria-hidden="true">
              </button>
              <button class="toolbar-icon" (click)="zoomOut()" [tooltip]="lang.tra('btn_zoom_out')" placement="left" [attr.aria-label]="lang.tra('btn_zoom_out')">
                  <img src="https://mathproficiencytest.ca/img/zoom-out.png" aria-hidden="true">
              </button>
              <button class="toolbar-icon" (click)="toggleLineReader()" [class.is-active]="isLineReaderActive"
                      [tooltip]="lang.tra('btn_line_reader')" placement="left" [attr.aria-label]="lang.tra('btn_line_reader')" [attr.aria-pressed]="getAriaPressed(isLineReaderActive)">
                  <img src="https://www.mathproficiencytest.ca/img/line_reader.png" aria-hidden="true">
              </button>
              <button class="toolbar-icon" (click)="toggleHiContrast()" [class.is-active]="isHighContrast" [tooltip]="lang.tra('btn_hi_contrast')"
                      placement="left" [attr.aria-label]="lang.tra('btn_hi_contrast')" [attr.aria-pressed]="getAriaPressed(isHighContrast)">
                   <!-- hi contrast -->
                  <img src="https://mathproficiencytest.ca/img/hi-contrast.png" aria-hidden="true">
              </button>
              <button *ngIf="!disableDrawingTools" type="button" class="toolbar-icon" (click)="setLine()" [class.is-active]="isShowOverlay && !showDeactivatedMode && showLine" [tooltip]="lang.tra('btn_toggle_editor')" placement="left" [attr.aria-label]="lang.tra('btn_toggle_editor')" [attr.aria-pressed]="getAriaPressed(isShowOverlay && !showDeactivatedMode && showLine)" data-test-id="toolbar-draw-line">
                  <i class="fas fa-edit" style="font-size: 2em; color:white;" aria-hidden="true"></i>
              </button>
              <button *ngIf="!disableDrawingTools" type="button" class="toolbar-icon" (click)="setHighlighter()" [class.is-active]="isShowOverlay && !showDeactivatedMode && showHighlight" [tooltip]="lang.tra('el_draw_highlighter')" placement="left" [attr.aria-label]="lang.tra('el_draw_highlighter')" [attr.aria-pressed]="getAriaPressed(isShowOverlay && !showDeactivatedMode && showHighlight)" data-test-id="toolbar-highlighter">
                  <i class="fas fa-highlighter" style="font-size: 2em; color:white;" aria-hidden="true"></i>
              </button>
              <button *ngIf="!disableDrawingTools" type="button" class="toolbar-icon" (click)="setEraser()" [class.is-active]="isShowOverlay && showEraser" [class.is-inactive]="!isShowOverlay || showDeactivatedMode" [tooltip]="lang.tra('btn_eraser')" placement="left" [attr.aria-label]="lang.tra('btn_eraser')" [attr.aria-pressed]="getAriaPressed(isShowOverlay && showEraser)" data-test-id="toolbar-eraser">
                  <i class="fas fa-eraser" style="font-size: 2em; color:white;" aria-hidden="true"></i>
              </button>
            </ng-container>



        </div>
        <div class="tools-bottom">
            <button *ngIf="documentItems && documentItems.length && isFormulasAvailable()"
            (click)="toggleDocuments()"
            class="toolbar-icon"
            [class.is-active]="isShowDocuments"
            [tooltip]="getDocumentTooltip()" placement="left"
            [attr.aria-label]="getDocumentTooltip()"
            [attr.aria-pressed]="getAriaPressed(isShowDocuments)"
            [attr.aria-expanded]="getAriaExpanded(isShowDocuments)"
            [attr.aria-controls]="getToolbarPanelId('documents')"
            data-test-id="toolbar-documents"
            >
            <img src="https://mathproficiencytest.ca/img/reference-book.png" aria-hidden="true">
        </button>
        <button *ngIf="isCalcAvailable()" (click)="toggleCalc()" class="toolbar-icon" [class.is-active]="isShowingCalc()" [tooltip]="lang.tra('btn_calculator')" placement="left" [attr.aria-label]="lang.tra('btn_calculator')">
            <img src="https://mathproficiencytest.ca/img/calculator.png" aria-hidden="true">
        </button>
        <button *ngIf="asmtFmrk && !asmtFmrk.isOrale && asmtFmrk.toolbarOptions.infoButton" #infoButton
            type="button" (click)="toggleInfoModal()" class="info-button-toolbar"
            [tooltip]="lang.tra('btn_info')" [attr.aria-label]="lang.tra('btn_info')" slug="btn_info"
            data-test-id="toolbar-info"
        >
            <img class="toolbar-icon-img-cal" src="https://eqao.vretta.com/authoring/user_uploads/96360/authoring/Info/1621008934819/Info.svg" alt="" aria-hidden="true">
        </button>
        <div class="debug-button is-embedded" (click)="triggerDebugModeAgg()"> </div>
    </div>
    <div class="toolbar-overflow-indicator" *ngIf="hasToolbarOverflow()">
        <span [tooltip]="lang.tra(getScrollingSlug())" placement="left">
            <button class="toolbar-icon" [attr.aria-label]="lang.tra(getScrollingSlug())" >
                <i class="fas fa-chevron-down toolbar-icon-icon" aria-hidden="true"></i>
            </button>
        </span>
    </div>
</div>

<div class="info-overlay" *ngIf="isShowingReport">
    <div class="info-box">
        <strong><tra slug="btn_report_issue"></tra></strong>
        <hr/>
        <textarea class="textarea" placeholder="Please describe the issue that you experienced in the box below" [formControl]="issueReportMessage" rows=6></textarea>
        <hr/>
        <div class="buttons">
            <button class="button" (click)="sendIssueReport()">
                Report Issue
            </button>
            <button class="button is-danger is-outlined" (click)="isShowingReport = false">
                Cancel
            </button>
        </div>
    </div>
</div>

<!--<div class="info-overlay" *ngIf="isShowDocuments">
    <div class="info-box is-maximized documents-container">
        <div [ngStyle]="{'font-size.em': zoomLevel}">
            <div style="display:flex; flex-direction:row; justify-content: space-between;">
                <menu-bar style="flex-grow:1" [menuTabs]="documentViews" (change)="selectDocumentView($event)" [tabIdInit]="selectedDocumentId"></menu-bar>
                <button type="button" class="button is-text" style="font-size:1.4em;" (click)="isShowDocuments = false" [attr.aria-label]="lang.tra('btn_close')">&times;</button>
            </div>
            <div *ngIf="activeDocument">
                <question-runner [currentQuestion]="activeDocument" [currentQuestionIndex]="0" [totalQuestions]="4"></question-runner>
            </div>
        </div>
</div> -->

<!-- <div class="chat-overlay" *ngIf="isShowingChat">
    <div class="info-box">
        <div>
            <button class="button is-fullwidth" (click)="isShowingChat=false">
                Close
            </button>
        </div>
        <hr/>
        <div>
            <test-taker [uid]="auth.user().value.uid" [instit_group_id]="instit_group_id" [markingPoolId]="testSessionId" [chatService]="chatService"></test-taker>
        </div>
    </div>
</div> -->
<div class="save-overlay" [class.is-activated]="isSavingResponse">
    <div class="overlay-bg"></div>
    <div class="overlay-text">
        <span class="tag is-warning">Saving...</span>
    </div>
</div>

<div class="expander" style="top:0em; left:0em;" *ngIf="!isTestNavExpanded">
    <button class="button" (click)="toggleTestNav()" aria-label="Expand question navigation" [attr.aria-expanded]="getAriaExpanded(isTestNavExpanded)" [attr.aria-controls]="getTestNavId()">
        <i class="fa fa-angle-double-right" aria-hidden="true"></i>
    </button>
</div>

<div class="expander" style="top:0em; right:0em;" *ngIf="!isToolbarExpanded">
    <button class="button" (click)="toggleToolbar()" aria-label="Expand toolbar" [attr.aria-expanded]="getAriaExpanded(isToolbarExpanded)" [attr.aria-controls]="getToolbarId()">
        <i class="fa fa-angle-double-left" aria-hidden="true"></i>
    </button>
</div>


<div class="info-overlay overlay-container" *ngIf="isShowingTime">
    <div class="info-box">
        <div #timeRemainingMessage class="popup-focus-target" tabindex="-1">
            <div> <strong><tra slug="test_time_remaining"></tra></strong> </div>
            <div style="font-size:1.4em;">{{renderDur(regularTimeRemaining, lang)}}</div>
        </div>
        <!-- <hr/> -->
        <!-- <div> <strong>Extra Time Remaining:</strong> </div> -->
        <!-- <div>02:00</div> -->
        <hr/>
        <div>
            <button class="button is-fullwidth" (click)="closeTimeRemaining()">
                OK
            </button>
        </div>
    </div>
</div>

<div *ngIf="isShowingConfirmationReport && testState.isSubmitted" class="report-container">
  <div class="report-modal">
    <div class="report-content" *ngIf="testSessionId !== -1">
      <div #completionReportMessage class="popup-focus-target" tabindex="-1">
        <ng-container [ngSwitch]="showFPS">
          <tra-md *ngSwitchCase="false" slug="txt_instr_review_report"></tra-md>
          <tra-md *ngSwitchCase="true" slug="txt_instr_review_perf_report"></tra-md>
        </ng-container>
        <tra-md slug="txt_finalize_submission"></tra-md>
      </div>
      <table class="table is-bordered" style="margin-top:1em;">
        <tr>
          <th><tra slug="lbl_name"></tra></th>
          <td>{{testTakerName}}</td>
        </tr>
        <tr>
          <th><tra slug="lbl_assessment"></tra></th>
          <td><tra slug="lbl_MPT"></tra><tra slug="lbl_mpt_perf_test"></tra></td>
        </tr>
        <tr *ngIf="confirmReportData && confirmReportData['attemptKey'] && !showFPS">
          <th><tra slug="txt_dummy_attempt_key"></tra> </th>
          <td>{{confirmReportData["attemptKey"]}}</td>
        </tr>
        <tr *ngIf="confirmReportData && confirmReportData['invigilator'] && !showFPS">
          <th><tra slug="lbl_invig_by"></tra> </th>
          <td>{{confirmReportData["invigilator"]}}<span> ({{confirmReportData["format"]}})</span></td>
        </tr>
        <tr>
          <th>Date</th>
          <td><tra-md [slug]="getDate()" [props]="{day: dayStarted, year: yearStarted}"></tra-md></td>
        </tr>
        <tr>
          <th><tra slug="lbl_started_at"></tra> </th>
          <td>{{getStartedAt()}}</td>
        </tr>
        <tr>
          <th><tra slug="lbl_time_spent"></tra> </th>
          <td>{{getTimeSpentSinceStart()}}</td>
        </tr>
        <tr *ngIf="showFPS">
          <th><tra slug="Avg FPS"></tra></th>
          <td>{{getTestAvgFps()}}</td>
        </tr>
        <tr *ngIf="showFPS">
          <th><tra slug="txt_device_fp"></tra></th>
          <td>{{getDeviceFingerprint()}}</td>
        </tr>

      </table>

      <hr/>

      <table *ngIf="confirmReportData" class="table is-bordered" style="    max-width: 17em; margin: auto;">
        <tr>
          <th style="width:8em;"><tra slug="ie_section"></tra></th>
          <th><tra slug="lbl_unfilled_responses"></tra></th>
          <th><tra slug="lbl_time_spent"></tra></th>
        </tr>
        <tr *ngFor="let section of currentTestDesign.sections; let index = index">
          <td><tra slug="ie_section"></tra> {{index+1}}</td>
          <td [textContent]="previousSessionMeta[index].numUnfilledResponses"></td>
          <td [textContent]="sectionTimeSpent[index] + ' minutes'"></td>
        </tr>
      </table>

      <hr/>
    </div>
    <div class="report-footer" [class.no-padding-top]="testSessionId == -1">
      <div> <button #completionActionButton class="button is-info" (click)="submitTest()" style="width:100%;"> <tra [slug]="testSessionId !== -1 ? 'btn_continue' : 'btn_exit_completion'"></tra> </button> </div>
      <!--<div> <button class="button is-info" (click)="confirmedSubmission()"> <tra slug="btn_tt_report_approve"></tra> </button> </div>
      <div> <button class="button" (click)="reportIssueThroughInvigilator()"> <tra slug="btn_tt_report_reject"></tra> </button> </div>-->
    </div>

  </div>
</div>

<!-- use no-display rather than ngIf since we need access to the ViewChild -->
<div class="chat-overlay overlay-container" [class.no-display]="!isShowingChat">
  <div class="info-box">
    <div class="chat-header">
      <div class="header-bookend"> <button class="button-close-chat" (click)="closeChat()" [attr.aria-label]="lang.tra('btn_close')"><i class="fa fa-times" aria-hidden="true"></i></button> </div>
      <div #chatHeading class="popup-focus-target" tabindex="-1"><tra slug="title_invig_messages"></tra></div>
      <div class="header-bookend"></div>
    </div>
    <div class="chat-body">
      <test-taker
        [uid]="auth.user().value?.uid"
        [instit_group_id]="instit_group_id"
        [markingPoolId]="testSessionId"
        [chatService]="chatService"
      ></test-taker>
    </div>
  </div>
</div>


<div *ngIf="isPrintMode" class="printed-test-form">
    <div>
        <strong> Test Form {{testFormId}}</strong>
        <!-- <div>The following sheets of paper must be shredded after digitization.</div> -->
    </div>
    <!-- section.isShuffleDisabled &&  !isShowQuestionLabel-->
    <div *ngFor="let section of currentTestDesign.sections; let index = index" [class.is-hidden]="">
        <div class="section-block">
            <h1 style="cursor:pointer;" (click)="toggleSectionPrint(index)">
                <tra [slug]="getSectionTitleSlug()"></tra> {{index+1}}
                <span [ngSwitch]="!!sectionPrintDisplayRef.get(index)" style="margin-left:1em;">
                    <i *ngSwitchCase="false" class="fas fa-caret-right"></i>
                    <i *ngSwitchCase="true" class="fas fa-caret-down"></i>
                </span>
            </h1>
            <ng-container *ngIf="sectionPrintDisplayRef.get(index)">
                <question-runner [currentQuestion]="getSectionPreambleContent(section)" [currentQuestionIndex]="0" [totalQuestions]="4"></question-runner>
            </ng-container>
        </div>
        <ng-container *ngIf="sectionPrintDisplayRef.get(index)">
            <div class="question-block" *ngFor="let question of section.questions; let qindex = index">
                <div style="border-top: 0.3em solid #666; padding:0.2em 0em;  font-weight:600; margin-top:1em;">
                    <tra [slug]="getSectionTitleSlug()"></tra> {{index+1}}, Question {{qindex+1}}
                    <span *ngIf="isShowQuestionLabel">[{{getQuestionLabel(question)}}]</span>
                </div>
                <question-runner [currentQuestion]="getQuestionDef(question)" [currentQuestionIndex]="0" [totalQuestions]="4" [questionState]="getQuestionState(question)"></question-runner>
            </div>
        </ng-container>
    </div>
</div>
<div class="debug-button" (click)="triggerDebugModeAgg()"> </div>
<div class="debug-box" *ngIf="isDebugMode">
    <div class="debug-content" cdkDrag>
        <div class="debug-current">
            <div class="debug-drag-bar" cdkDragHandle></div>
            <div><b>Current Form:</b> {{this.testFormId}}</div>
            <div><b>Current Label:</b> {{getQuestionLabel(getCurrentQuestionId())}}</div>
            <div><b>Current ID:</b> {{getCurrentQuestionId()}}</div>
            <div style="margin-top:1em"><button (click)="isDebugMode = false">x Close Debug Mode</button></div>
        </div>

        <div class="debug-last" *ngIf="lastResponseDebug">
            <div><b>Last Label:</b> {{lastResponseDebug.label}}</div>
            <div><b>Last Score:</b> {{lastResponseDebug.score}} / {{lastResponseDebug.weight}}</div>
            <div><b>Last Response:</b> {{lastResponseDebug.formatted_response}}</div>
        </div>
    </div>
</div>

<div class="custom-modal" *ngIf="cModal()" [ngClass]="cModal().type">
  <div class="modal-contents">
    <div [ngSwitch]="cModal().type">
      <div *ngSwitchCase="PrivateCallModal.PRIVATE_CALL_MODAL">
        <div *ngIf="privateCallLink && verificationCallActive">
          <iframe
            id="iframe-private-call"
            allow="camera; microphone; display-capture; fullscreen;"
            [src]="privateCallLink"
          ></iframe>
          <tra-md slug="txt_breakout_room_caption"></tra-md>
        </div>
        <modal-footer [pageModal]="pageModal" [isConfirmAlert]="false" ></modal-footer>
      </div>
    </div>
  </div>
</div>
